import { render } from "./SizingRow.vue?vue&type=template&id=e7f8308c"
import script from "./SizingRow.vue?vue&type=script&lang=js"
export * from "./SizingRow.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__